import React, { useState } from 'react';
import {
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Typography,
    Box,
    Checkbox,
    FormControlLabel,
} from '@material-ui/core';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';
import NavResponsiveModal from '@/components/Navigation/NavResponsiveModal';

const MIN_REVERT_REASON_LENGTH = 10;

export default function RevertDeliveryModal({ open, onClose, onConfirm, loading = false }) {
    const [reason, setReason] = useState('');
    const [clearDocuments, setClearDocuments] = useState(true);

    const canConfirm = reason.length >= MIN_REVERT_REASON_LENGTH && !loading;

    const reset = () => {
        setReason('');
        setClearDocuments(true);
    };

    const handleConfirm = () => {
        onConfirm({ reason: reason.trim(), clearDocuments }).then(() => {
            reset();
            onClose();
        });
    };

    const handleClose = () => {
        reset();
        onClose();
    };

    return (
        <NavResponsiveModal open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Revert delivery</DialogTitle>
            <DialogContent>
                <Typography variant="body2" gutterBottom>
                    This will move the order back to <strong>In Transit</strong>. Use this if the driver marked delivery
                    complete by mistake.
                </Typography>
                <Box mt={2}>
                    <TextField
                        label="Reason (required)"
                        multiline
                        minRows={3}
                        fullWidth
                        variant="outlined"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        disabled={loading}
                    />
                </Box>
                <Box mt={1}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={clearDocuments}
                                onChange={(e) => setClearDocuments(e.target.checked)}
                                disabled={loading}
                                color="primary"
                            />
                        }
                        label="Also clear uploaded POD and delivery photos"
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <SecondaryButton onClick={handleClose} disabled={loading}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton onClick={handleConfirm} disabled={!canConfirm}>
                    Revert
                </PrimaryButton>
            </DialogActions>
        </NavResponsiveModal>
    );
}
